<template>
  <div></div>
</template>
<script>
import firebaselogin from './firebaselogin'
export default {
  name: 'pre-login',
  mixins: [firebaselogin],
  props: {
    reissueKey: String,
    nonce: String
  },
  data() {
    return {
      cpno: window.Laravel.cpno,
      token: window.Laravel.csrfToken
    }
  }
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/PreLogin.vue